import { Navigate } from 'react-router-dom';

/**
 * AdminRoute component - Guards admin-only routes
 * Checks for admin authentication independent of user AuthContext
 */
const AdminRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  const adminInfo = localStorage.getItem('adminInfo');
  
  // If no admin authentication found, redirect to admin login
  if (!adminToken || !adminInfo) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Admin is authenticated, render the protected component
  return children;
};

export default AdminRoute;
